import {Action} from '../../actions/index';
import {ActionTypes, Offer} from './types';

const initialState: OfferState = {
  fetchedOffer: false,
  offer: {}
};

export interface OfferState {
  offer: Offer;
  fetchedOffer: boolean;
}

const OfferReducer = (state: OfferState = initialState, action: Action): OfferState => {
  switch (action.type) {
    case ActionTypes.FETCH_OFFER_LIST_PENDING: {
      return {
        ...state,
        fetchedOffer: false
      };
    }
    case ActionTypes.FETCH_OFFER_LIST_FULFILLED: {
      return {
        ...state,
        fetchedOffer: true,
        offer: action.payload as Offer
      };
    }
    case ActionTypes.FETCH_OFFER_LIST_REJECTED: {
      return {
        ...state,
        fetchedOffer: true
      };
    }
    case ActionTypes.NO_OFFER_FOUND: {
      return {
        ...state,
        fetchedOffer: true
      };
    }
    default: {
      return state;
    }
  }
};

export default OfferReducer;
